import { BrandingOverrideProvider } from '@/hooks/use-branding'

import Footer from '@/components/layouts/footer'

import { getNonFsdsFooterBrandingOverride, getNonFsdsFooterConfig } from '@/configs/non-fsds-config'

import { FooterConfig } from '@/types/header-footer-config'

interface PuckFooterSectionProps {
  visible?: boolean
  fallbackLogoUrl?: string
  brandHref?: string
  brandName?: string
  footerConfig?: FooterConfig
}

export default function PuckFooterSection({
  visible = true,
  fallbackLogoUrl = '',
  brandHref = '/',
  brandName = '',
  footerConfig,
}: PuckFooterSectionProps) {
  if (!visible) return null

  return (
    <BrandingOverrideProvider
      value={getNonFsdsFooterBrandingOverride({ brandHref, fallbackLogoUrl, brandName })}
    >
      <section className="puck-footer-section overflow-hidden rounded-lg border border-dashed border-border bg-background">
        <div className="relative">
          <Footer footerConfig={getNonFsdsFooterConfig(footerConfig)} />
        </div>
      </section>
    </BrandingOverrideProvider>
  )
}
